module.exports = __webpack_public_path__ + "img/easy_rent_a_car1.866f7d01.jpg";